// extracted by mini-css-extract-plugin
export var animated = "CookieBanner-module--animated--4e24a";
export var closeIcon = "CookieBanner-module--closeIcon--e5368";
export var cookieBanner = "CookieBanner-module--cookieBanner--b0eeb";
export var cookieBannerContents = "CookieBanner-module--cookieBannerContents--bc16f";
export var fadeInUp = "CookieBanner-module--fadeInUp--615fb";